/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_HardInputs */

const en_us2_workout_quick_effort_hard = /** @type {(inputs: Workout_Quick_Effort_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hard`)
};

const pt_br2_workout_quick_effort_hard = /** @type {(inputs: Workout_Quick_Effort_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puxado`)
};

const es_419_workout_quick_effort_hard = /** @type {(inputs: Workout_Quick_Effort_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duro`)
};

const pt_pt2_workout_quick_effort_hard = /** @type {(inputs: Workout_Quick_Effort_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puxado`)
};

const fr_fr2_workout_quick_effort_hard = /** @type {(inputs: Workout_Quick_Effort_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dur`)
};

const de_de2_workout_quick_effort_hard = /** @type {(inputs: Workout_Quick_Effort_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwer`)
};

const it_it2_workout_quick_effort_hard = /** @type {(inputs: Workout_Quick_Effort_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duro`)
};

/**
* | output |
* | --- |
* | "Hard" |
*
* @param {Workout_Quick_Effort_HardInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_hard = /** @type {((inputs?: Workout_Quick_Effort_HardInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_HardInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_hard(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_hard(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_hard(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_hard(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_hard(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_hard(inputs)
	return en_us2_workout_quick_effort_hard(inputs)
});
export { workout_quick_effort_hard as "workout-quick.effort_hard" }